import { FullReport, QueryParams, Report, StatusResult } from "../types/types";

export const reportRepo2 = (checkId: number, location: string, ts: Date, token: string): Promise<Report> => {
  const API_URL = "/api";
  return fetch(`${API_URL}?checkId=${checkId}&location=${location}&ts=${ts.toISOString()}&token=${token}`)
    .then((res) => res.json())
    .then((result) => result.data);
};

export const reportRepo = (qParams?: QueryParams): Promise<Report> => {
  if(!qParams) {
    return Promise.reject("missing required query param");
  }
  else {
    const API_URL = "/api";
    return fetch(`${API_URL}?checkId=${qParams.checkId}&location=${qParams.location}&ts=${qParams.date.toISOString()}&token=${qParams.token}`)
      .then((res) => res.json())
      .then((result) => result.data);
  }
 
};

export const statusRepo = (checkId: number, location: string, ts: Date, token: string): Promise<StatusResult> => {
  const API_URL = "/status";
  return fetch(`${API_URL}?checkId=${checkId}&location=${location}&ts=${ts.toISOString()}&token=${token}`)
    .then((res) => res.json())
    .then((result) => result.data);
};


export const fullReport = (id: number, location: string, ts: Date, token: string): Promise<FullReport> => {
  return Promise.all([statusRepo(id, location, ts, token), reportRepo2(id, location, ts, token)]).then(
    (values) => {
        return { report: values[1], status: values[0] };
    }
  );
};

